export type HandlerKind = 'RequestHandler' | 'EventHandler'
